import React from "react";
import { Grid, Typography, RadioGroup, FormControlLabel, Radio } from "@mui/material";

export default function CheckBelonging({ value, onChange }) {
  const handleChange = (e) => {
    onChange({ belonging: Number(e.target.value) });
  };

  return (
    <>
      <Grid
        item
        xs={4}
        sm={2}
        sx={{
          fontWeight: "bold",
          paddingLeft: { sm: "20px" },
          paddingTop: "10px",
          paddingBottom: "20px",
        }}
      >
        商流の程度
      </Grid>

      <Grid
        item
        xs={8}
        sm={4.5}
        sx={{
          paddingLeft: "20px",
          paddingTop: "10px",
          paddingBottom: "20px",
        }}
      >
        <RadioGroup value={value} row onChange={handleChange}>
          <FormControlLabel
            value={0}
            label={<Typography>なし</Typography>}
            control={<Radio sx={{ "&.Mui-checked": { color: "#28345E" } }} />}
          />
          <FormControlLabel
            value={1}
            label={<Typography>直契約のみ</Typography>}
            control={<Radio sx={{ "&.Mui-checked": { color: "#28345E" } }} />}
          />
          <FormControlLabel
            value={2}
            label={<Typography>再委託１社目</Typography>}
            control={<Radio sx={{ "&.Mui-checked": { color: "#28345E" } }} />}
          />
        </RadioGroup>
      </Grid>
    </>
  );
}